import { Component, OnInit } from '@angular/core';
import { UntypedFormControl as FormControl, UntypedFormGroup as FormGroup } from '@angular/forms';
import { TranslationService } from '@sdbn/common';
import { AbstractWidgetComponent, WidgetStyle } from '@sdbn/appclient';
import { ContextChange } from '@sdbn/appclient';
import { StructureNode } from '../timeframe-matching/structure-node';
import { ReportDaySelection } from './report-day-selection.model';
@Component({
  selector: 'app-report-day-selection',
  templateUrl: './report-day-selection.component.html',
  styleUrls: ['./report-day-selection.component.scss']
})
export class ReportDaySelectionWidget extends AbstractWidgetComponent implements OnInit {

  formGroup = new FormGroup({});

  selectedStructureNode: StructureNode;

  date = new Date();
  private ONE_DAY_DURATION: number = 24 * 60 * 60 * 1000;

  constructor(
    public translationService: TranslationService
  ) {
    super();

    this.formGroup.addControl('date', new FormControl(new Date(), []));

    this.formGroup.valueChanges.subscribe(values => {
      this.date = values.date;
      this.handleSelectionChange();
    });

  }

  ngOnInit(): void {
  }

  onContextChange(contextChange: ContextChange) {
  }

  onSetElementAndContext() {

  }

  public onSelectedStructureChanged(structureNode: StructureNode) {
    this.selectedStructureNode = structureNode;
    this.handleSelectionChange();
  }

  setPreviewsDay() {
    this.date = new Date(this.date.getTime() - this.ONE_DAY_DURATION);
    this.formGroup.patchValue({
      date: this.date
    });
  }

  setNextDay() {
    this.date = new Date(this.date.getTime() + this.ONE_DAY_DURATION)
    this.formGroup.patchValue({
      date: this.date
    });
  }

  handleSelectionChange() {

    this.dashboardContext.setContextValue('report-day-selection', new ReportDaySelection({ date: this.date, structureNode: this.selectedStructureNode }));

  }

  getStyle(): WidgetStyle {
    return WidgetStyle.transparent;
  }
}
